type NameFields = Partial<{ firstName: string | null; lastName: string | null }>;

export function getFullName<T extends NameFields>(person?: T | null, separator: string = ' '): string {
    if (!person) return '';
    return [person?.firstName?.trim(), person?.lastName?.trim()].filter(Boolean).join(separator).trim();
}
export function generateNameInitials(name?: string | null): string {
    const trimmedName = name?.trim();
    if (!trimmedName) return '?';
    const parts = trimmedName.split(/\s+/);
    const first = parts[0].charAt(0);
    if (parts.length === 1) return first;
    const last = parts[parts.length - 1].charAt(0);

    return (first + last).toUpperCase();
}
export const removeSpaces = (value: string = ''): string => value.replace(/\s/g, '');
export const namePart = (value?: string | null) => (value || '').trim().toUpperCase();
/** Same first and last name, ignoring case. A missing name counts as ''. */
export function isSameName<TA extends NameFields, TB extends NameFields>(
    a?: TA | null,
    b?: TB | null
): boolean {
    if (!a || !b) return false;
    return namePart(a.firstName) === namePart(b.firstName) && namePart(a.lastName) === namePart(b.lastName);
}
